import { Button, Form, Modal, Input, Divider, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getAppCreatedAtMillis, getCachedApps } from "../../utils/appCache";
export default function CreateModal({ appList, fetchData }) {
  
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [latestAppList, setLatestAppList] = useState([]);
  const [loadingApps, setLoadingApps] = useState(false);
  const [creating, setCreating] = useState(false);
  const creatingRef = useRef(false);

  const productGroupsCollection = collection(db, "productGroups");

  const getAppCode = (item) =>
    String(
      item?.nameLower ||
        String(item?.name || "")
          .toLowerCase()
          .replace(/\s+/g, ""),
    ).trim();

  const showModal = async () => {
    setOpen(true);
    setLoadingApps(true);

    try {
      const apps = await getCachedApps({ force: true });
      setLatestAppList(Array.isArray(apps) ? apps.filter(Boolean) : []);
    } catch (error) {
      console.error("Load apps for create product error:", error);
      setLatestAppList(Array.isArray(appList) ? appList.filter(Boolean) : []);
    } finally {
      setLoadingApps(false);
    }
  };

  const selectableApps = Array.from(
    [...(appList || []), ...latestAppList].reduce((apps, item, index) => {
      if (!item) return apps;

      const identity = item.key || getAppCode(item) || `app-${index}`;
      apps.set(identity, item);
      return apps;
    }, new Map()).values(),
  );
  const appOptions = [...selectableApps]
    .sort((a, b) => {
      const createdAtDifference =
        getAppCreatedAtMillis(b) - getAppCreatedAtMillis(a);

      if (createdAtDifference !== 0) return createdAtDifference;

      return String(a?.name || "").localeCompare(String(b?.name || ""), "th");
    })
    .map((item) => {
      const label = String(item?.name || "").trim();
      const appCode = getAppCode(item);
      const value = String(item?.key || appCode).trim();

      return label && value ? { label, value } : null;
    })
    .filter(Boolean);

  const createProduct = async (value) => {
    if (creatingRef.current) return;
    creatingRef.current = true;
    setCreating(true);

    try {
      const selectedApp = selectableApps.find(
        (item) => String(item?.key || getAppCode(item)) === value?.app,
      );
      const selectedAppCode = getAppCode(selectedApp) || value?.app;

      const docRef = await addDoc(productGroupsCollection, {
        name: value?.name,
        app: selectedAppCode,
        status: "available",
        cloneTo: null,
        // ...(description?.trim() ? { description: description.trim() } : {}),
        createdAt: serverTimestamp(),
      });
      console.log("Document written with ID: ", docRef.id);
      form?.resetFields();
      await fetchData?.();
      setOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      creatingRef.current = false;
      setCreating(false);
    }
  };

  return (
    <>
      <Button
        onClick={showModal}
        className="neo-btn-glass"
        icon={<PlusOutlined />}
      >
        เพิ่มสินค้า
      </Button>

      {/* MODAL */}
      <Modal
        width={500}
        open={open}
        footer={false}
        closeIcon={false}
        centered
        className="neo-modal"
      >
        <div className="neo-modal-header">
          <div>
            <div className="neo-modal-topline">MANAGEMENT</div>

            <div className="neo-modal-title">📦 เพิ่มสินค้า</div>
          </div>

          <Button
            className="neo-close-btn"
            onClick={() => {
              setOpen(false);
              form?.resetFields();
            }}
          >
            ✕
          </Button>
        </div>

        <Divider
          style={{
            borderColor: "rgba(255,255,255,0.08)",
            margin: "18px 0px",
          }}
        />

        <Form form={form} layout="vertical" onFinish={createProduct}>
          <div className="neo-form-label">ชื่อสินค้า</div>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "กรุณากรอกชื่อสินค้า",
              },
            ]}
          >
            <Input
              placeholder="เช่น Disney Plus Premium"
              className="neo-input-modal"
            />
          </Form.Item>

          <div className="neo-form-label">Application</div>
          <Form.Item
            name="app"
            rules={[
              {
                required: true,
                message: "กรุณาเลือก App",
              },
            ]}
          >
            <Select
              loading={loadingApps}
              showSearch
              optionFilterProp="label"
              options={appOptions}
              listHeight={400}
              popupClassName="neo-select-dropdown"
              placeholder="เลือก App"
              className="neo-input-modal"
            />
          </Form.Item>

          {/* <div className="neo-form-label">คำอธิบายสินค้า</div>
          <Form.Item name="description">
            <TiptapEditor value={description} onChange={setDescription} />
          </Form.Item> */}

          {/* FOOTER BUTTON */}
          <div className="neo-modal-footer">
            <Button
              className="neo-cancel-btn"
              disabled={creating}
              onClick={() => {
                setOpen(false);
                form?.resetFields();
              }}
            >
              ยกเลิก
            </Button>

            <Button
              htmlType="submit"
              className="neo-save-btn"
              loading={creating}
              disabled={creating}
            >
              + เพิ่มสินค้า
            </Button>
          </div>
        </Form>
      </Modal>

      {/* STYLE */}
      <style>{`

/* =========================
   OPEN BUTTON
========================= */

.neo-btn-glass{
    height:42px !important;

    padding:0 18px !important;

    border-radius:18px !important;

    background:rgba(255, 255, 255, 0.05) !important;

    border:1px solid rgba(255,255,255,.08) !important;

    color:white !important;

    font-weight:700;

    backdrop-filter:blur(18px);

    transition:.25s;
}

.neo-btn-glass:hover{
    transform:translateY(-2px);

    background:rgba(255,255,255,.08) !important;

    border-color:rgba(248,204,70,.35) !important;
}

/* =========================
   MODAL
========================= */

.neo-modal .ant-modal-content{
  background:
    linear-gradient(
      135deg,
      rgba(255,255,255,.10),
      rgba(255,255,255,.03)
    ) !important;

  backdrop-filter:blur(26px);
  -webkit-backdrop-filter:blur(26px);

  border:
    1px solid rgba(255,255,255,.08);

  border-radius:30px;

  padding:26px;

  overflow:hidden;

  box-shadow:
    0 25px 60px rgba(0,0,0,.35);
}

.neo-modal .ant-modal-mask{
  backdrop-filter:blur(6px);
}

/* =========================
   HEADER
========================= */

.neo-modal-header{
  display:flex;
  justify-content:space-between;
  align-items:flex-start;

  gap:16px;
}

.neo-modal-topline{
  color:#fbbf24;

  font-size:12px;
  font-weight:800;

  letter-spacing:3px;
}

.neo-modal-title{
  color:white;

  font-size:28px;
  font-weight:900;

  margin-top:4px;
}

.neo-close-btn{
  width:42px;
  height:42px;

  border:none !important;

  border-radius:14px !important;

  background:
    rgba(255,255,255,.08) !important;

  color:white !important;

  transition:.25s;
}

.neo-close-btn:hover{
  background:
    rgba(255,255,255,.14) !important;

  color:white !important;
}

/* =========================
   LABEL
========================= */

.neo-form-label{
  display:block;

  color:#fbbf24;

  font-size:12px;
  font-weight:800;

  letter-spacing:2px;

  margin-bottom:8px;

  text-transform:uppercase;
}

.neo-modal .ant-form-item-label > label{
  color:white !important;

  font-weight:700;
}

/* =========================
   INPUT
========================= */

.neo-input-modal.ant-input{
  height:52px !important;

  background:
    rgba(255,255,255,.06) !important;

  border:
    1px solid rgba(255,255,255,.08) !important;

  border-radius:16px !important;

  color:white !important;

  box-shadow:none !important;
}

.neo-input-modal.ant-input::placeholder{
  color:#94a3b8;
}

.neo-input-modal.ant-input:focus{
  border-color:#fbbf24 !important;

  box-shadow:
    0 0 0 3px rgba(251,191,36,.12) !important;
}

/* =========================
   SELECT
========================= */

.neo-input-modal.ant-select{
  width:100%;
  background:transparent !important;
}

.neo-input-modal.ant-select .ant-select-selector{
  height:52px !important;

  display:flex !important;
  align-items:center !important;

  background:
    rgba(255,255,255,.06) !important;

  border:
    1px solid rgba(255,255,255,.08) !important;

  border-radius:16px !important;

  color:white !important;

  box-shadow:none !important;
}

.neo-input-modal.ant-select-focused .ant-select-selector{
  border-color:#fbbf24 !important;

  box-shadow:
    0 0 0 3px rgba(251,191,36,.12) !important;
}

.neo-input-modal .ant-select-selection-item{
  color:white !important;
}

.neo-input-modal .ant-select-selection-placeholder{
  color:#94a3b8 !important;
}

.neo-input-modal .ant-select-arrow{
  color:#fbbf24 !important;
}

/* =========================
   DROPDOWN
========================= */

.ant-select-dropdown{
  background:#171717 !important;

  border:
    1px solid rgba(255,255,255,.08);

  border-radius:16px;

  overflow:hidden;
}

.ant-select-item{
  color:white !important;
}

.ant-select-item-option-active{
  background:
    rgba(251,191,36,.10) !important;
}

.ant-select-item-option-selected{
  background:
    rgba(251,191,36,.18) !important;

  color:#fbbf24 !important;
}

/* =========================
   DIVIDER
========================= */

.neo-modal .ant-divider{
  border-color:
    rgba(255,255,255,.08) !important;
}

/* =========================
   TIPTAP
========================= */

.neo-modal .ProseMirror{
  min-height:180px;

  padding:16px;

  border-radius:16px;

  background:
    rgba(255,255,255,.06);

  border:
    1px solid rgba(255,255,255,.08);


  outline:none;
}


.neo-modal .ProseMirror:focus{
  border-color:#fbbf24;

  box-shadow:
    0 0 0 3px rgba(251,191,36,.12);
}

/* =========================
   FOOTER
========================= */

.neo-modal-footer{
  display:flex;

  gap:12px;

  margin-top:24px;
}

.neo-modal-footer button{
  flex:1;
}

/* =========================
   CANCEL BUTTON
========================= */

.neo-cancel-btn{
  height:52px !important;

  border:none !important;

  border-radius:16px !important;

  background:
    rgba(255,255,255,.08) !important;

  color:white !important;

  font-weight:700 !important;

  transition:.25s;
}

.neo-cancel-btn:hover{
  background:
    rgba(255,255,255,.14) !important;

  color:white !important;
}

/* =========================
   SAVE BUTTON
========================= */

.neo-save-btn{
  height:42px !important;

  border:none !important;

  border-radius:14px !important;

  background:
    linear-gradient(
      135deg,
      #fbbf24,
      #dc2626
    ) !important;

  color:white !important;

  font-weight:800 !important;

  box-shadow:
    0 14px 35px rgba(220,38,38,.35);

  transition:.25s;
}

.neo-save-btn:hover{
  transform:translateY(-2px);

  filter:brightness(1.05);

  box-shadow:
    0 18px 45px rgba(220,38,38,.45);
}

/* =========================
   VALIDATION
========================= */

.neo-modal .ant-form-item-explain-error{
  color:#f87171 !important;
}

/* =========================
   MOBILE
========================= */

@media (max-width: 768px), (min-width: 769px) and (max-width: 1366px) and (pointer: coarse){

  .neo-modal .ant-modal-content{
    padding:20px;

    border-radius:24px;
  }

  .neo-modal-title{
    font-size:22px;
  }
}

`}</style>
    </>
  );
}
